import { render, staticRenderFns } from "./TextHeading.vue?vue&type=template&id=bd5014fc&scoped=true&"
import script from "./TextHeading.vue?vue&type=script&lang=js&"
export * from "./TextHeading.vue?vue&type=script&lang=js&"
import style0 from "./TextHeading.vue?vue&type=style&index=0&id=bd5014fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5014fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
